import { Component, OnInit, ViewChild} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Guest, GuestService, RoleService, UserService, User } from 'app/shared';
import { GuestRole } from 'app/shared/models/guest-role.model';
import { Role } from 'app/shared/models/role.model';
import { GuestRoleService } from 'app/shared/services/guest-role.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { GuestRoleFilter } from 'app/shared/models/guest-role-filter.model';

@Component({
    selector: 'app-manage-guests',
    templateUrl: './manage-guests.component.html',
    styleUrls: ['./manage-guests.component.scss'],
    standalone: false
})
export class ManageGuestsComponent implements OnInit{
  user: User;
  displayedColumns: string[] = [ 'guestName', 'guestINumber', 'roleName', 'createdOn', 'startDate', 'endDate'];
  dataSource: MatTableDataSource<GuestRole>;
  guestRoles: GuestRole[];
  guestRole: GuestRole;
  roles: Role[];
  roleFilter: number;
  firstNameFilter: string = '';
  lastNameFilter: string = '';
  inactiveFilter: boolean = false;
  loading: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private guestService: GuestService,
    private guestRoleService: GuestRoleService,
    private roleService: RoleService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router) {}


  ngOnInit() {
    this.filterGuestRoles();
    // this.route.queryParams.subscribe(params => {
    //   this.firstNameFilter = params.firstName ? params.firstName : '';
    //   this.lastNameFilter = params.lastName ? params.lastName : '';
    //   this.inactiveFilter = params.inactive == 'true' ? true : false;
    //   this.roleFilter = params.role ? parseInt(params.role) : null;
    //   this.filterGuestRoles();
    // });

    this.user = this.userService.user();
    this.roleService.getRolesByUser().subscribe(
      result => {
        this.roles = result
      }
    )
  }

  displayGuest(guestRole: GuestRole) {
    this.guestRole = guestRole;
  }

  cancelEdit() {
    this.guestRole = null;
  }

  filterGuestRoles() {
    this.dataSource = new MatTableDataSource<GuestRole>(null);
    this.loading = true;

    let filter = new GuestRoleFilter();
    filter.firstName = this.firstNameFilter;
    filter.lastName = this.lastNameFilter;
    filter.roleId = this.roleFilter ? this.roleFilter.toString() : '';
    filter.includeInactive = this.inactiveFilter ? 'true' : 'false';
    
    this.guestRoleService.getFilteredGuestRoles(filter).subscribe({
      next: guestRoles => {
        this.guestRoles = guestRoles;
        this.loading = false;
      },
      error: e => {
        alert('Error. Unable to load guests.')
        this.loading = false;
      },
      complete: () => this.loading = false
    })
  }
}